import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

// Mental Health Graphic
var graphic = document.querySelector('.mental-health-graphic');


if (graphic) {
  var triggers = graphic.querySelectorAll('.mental-health-graphic__trigger');
  ScrollTrigger.create({
    trigger: graphic,
    start: "top 70%",
    end: "bottom 100px",
    onEnter: () => graphic.classList.add('is-active')
  });

  triggers.forEach((trigger) => {
   trigger.addEventListener('click', (e)=>{
      var id = trigger.dataset.graphic

      // Phone Graphics
      var phones = document.querySelectorAll('.mental-health-graphic__phone img');
      phones.forEach((phone) => {  
        phone.classList.remove('is-active');
      });
      var phone = document.querySelector('.mental-health-graphic__phone--' + id);
      phone.classList.add('is-active');


      // Texts
      var texts = document.querySelectorAll('.mental-health-graphic__text p');
      texts.forEach((text) => {  
        text.classList.remove('is-active');
      });
      var text = document.querySelector('.mental-health-graphic__text--' + id);
      text.classList.add('is-active');


     triggers.forEach((trigger) => {  
       trigger.classList.remove('is-active');
     });
     trigger.classList.add('is-active');
   });
  });   
}
